/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_Item_2Inputs */

const es_tyc_obligations_s42_item_2 = /** @type {(inputs: Tyc_Obligations_S42_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizar el Servicio para actividades ilegales, difamatorias o que infrinjan derechos de propiedad intelectual.`)
};

const en_tyc_obligations_s42_item_2 = /** @type {(inputs: Tyc_Obligations_S42_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the Service for illegal, defamatory activities or activities that infringe intellectual property rights.`)
};

/**
* | output |
* | --- |
* | "Use the Service for illegal, defamatory activities or activities that infringe intellectual property rights." |
*
* @param {Tyc_Obligations_S42_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_item_2 = /** @type {((inputs?: Tyc_Obligations_S42_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_item_2(inputs)
	return en_tyc_obligations_s42_item_2(inputs)
});
export { tyc_obligations_s42_item_2 as "tyc.obligations.s42_item_2" }